import { ControlGroup, InputGroup, ITreeNode, NonIdealState, Tree } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import * as editActions from "core/actions/editActions";
import initialState from 'core/reducers/initialState';


interface IPanelListStateProps {
	active: editActions.IActiveArgs | null;
	panels: { [instance: string]: object };
}

interface IPanelListDispatchProps {
	actions: typeof editActions;
}

type ResultProps = IPanelListStateProps & IPanelListDispatchProps;

function mapStateToProps(state: typeof initialState = initialState): IPanelListStateProps {

	return {
		active: state.edit.active,
		panels: state.config.panels
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IPanelListDispatchProps {

	return {
		actions: bindActionCreators(editActions, dispatch)
	};
}

interface IPanelListState {
	query?: string;
}

class PanelList extends React.Component<ResultProps, IPanelListState> {

	public state: IPanelListState = { query: "" };

	public render() {

		if (!this.props.panels || Object.keys(this.props.panels).length < 1) {
			return (
				<NonIdealState title="No Panels" description="add some i guess" />
			);
		}

		return (
			<div>
				<div>
					<ControlGroup fill={true}>
						<InputGroup
							onChange={this.onChangeQuery}
							leftIcon={IconNames.SEARCH}
							placeholder="Find Panels..."
							value={this.state.query}
						/>
					</ControlGroup>
				</div>

				<Tree
					contents={
						this.state.query ? Object.entries(this.props.panels).filter(([_, config]) => {
							return (config['__editName'] || config['editName'] || '').toLowerCase().indexOf(this.state.query.toLowerCase()) > -1;
						}).map(this.toTreeNode) : Object.entries(this.props.panels).map(this.toTreeNode)
					}
					onNodeClick={this.onNodeClick}
				/>
			</div>
		);
	}

	private toTreeNode = ([instance, config]): ITreeNode<string> => {

		return {
			id: instance,
			label: config['__editName'] || config['editName'] || "(Untitled)",
			nodeData: instance,
			isSelected: (this.props.active && this.props.active.instance === instance)
		};
	}

	private onNodeClick = (node: ITreeNode<string>) => {
		this.props.actions.editSetActive(
			(this.props.active && this.props.active.instance === node.nodeData) ? null : { type: 'panel', instance: node.nodeData }
		);
	}

	private onChangeQuery = (e: any) => this.setState({query: e.target.value});
}

export default connect(mapStateToProps, mapDispatchToProps)(PanelList);



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelList.tsx